module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Unterentfelden-50ddcb8e9c836d04860de296fa2c3ba6.svg";